<template>
    <div style="overflow-y: auto; max-height: 455px;">
        <label>{{ $t('partido.tus_invitaciones') }}</label>
        <div 
            v-for="(asiento, index) in asientos" 
            class="lightgray-content p-2 mb-2 d-flex justify-content-between align-items-center"
            :key="index"
        >
            <div class="text-bold d-md-flex">
                <div class="oswald">
                    {{ $t('partido.invitacion')}} Nº {{ index + 1 }}. 
                </div>
                <div class="ml-2" v-if="asiento.asiento && typeof asiento.asiento === 'object'">
                    <small v-if="asiento.asiento.fila">{{ $t('general.fila') }}: {{ asiento.asiento.fila }} / </small> 
                    <small v-if="asiento.asiento.asiento">{{ $t('general.butaca') }}: {{ asiento.asiento.asiento }}</small>
                    <small v-if="asiento.asiento.visibilidad_reducida" class="text-danger">
                        - {{ nombreVisibilidadReducida }}
                    </small>
                    <small v-if="asiento.asiento.porcentaje_visibilidad" class="text-danger">
                        : {{ asiento.porcentaje_visibilidad }}%
                    </small>
                </div>
            </div>

            <span 
                class="ml-2 mr-1 red font-weight-bold cursor-pointer"
                role="button"
                @click="$emit('eliminarAsiento', asiento)"
            >
                ✕
            </span>
        </div>
    </div>
</template>

<script>
    import { claveVisibilidad } from '@/utils/visibilidadReducida';

    export default {
        props: {
            asientos: {
                type: Array,
                required: true
            }
        },
        computed: {
            nombreVisibilidadReducida() {
                return this.$t(claveVisibilidad('visibilidad_reducida.nombre', this.$route?.params?.sesion_id ?? null, clave => this.$te(clave)));
            }
        }
    }
</script>
